// src/extenders/product-media-scroll-indicator.js
var ProductMediaScrollIndicatorDesktop = class extends HTMLElement {
  constructor() {
    super();
    const sliderbar = this;
    const sliderbarButton = document.getElementById("sliderbar-button");
    const productMedia = document.getElementById("product-media");
    scroll();
    productMedia.addEventListener("scroll", function() {
      scroll();
    });
    function scroll() {
      const scrollTop = productMedia.scrollTop;
      const scrollHeight = productMedia.scrollHeight;
      const clientHeight = productMedia.clientHeight;
      const sliderbarHeight = sliderbar.clientHeight;
      const sliderbarButtonHeight = 500;
      const sliderbarButtonTop = scrollTop / (scrollHeight - clientHeight) * (sliderbarHeight - sliderbarButtonHeight);
      sliderbarButton.style.height = `${sliderbarButtonHeight}px`;
      sliderbarButton.style.top = `${sliderbarButtonTop}px`;
    }
  }
};
if (customElements.get("product-media-scroll-indicator-desktop") === void 0) {
  customElements.define("product-media-scroll-indicator-desktop", ProductMediaScrollIndicatorDesktop);
}
var ProductMediaScrollIndicatorMobile = class extends HTMLElement {
  constructor() {
    super();
    const productMediaSlider = document.querySelector('[data-role="product-media-slider"]');
    const sliderIndicatorMobile = this;
    const initSlideWidth = 100 / productMediaSlider.querySelector(".swiper-wrapper").children.length;
    sliderIndicatorMobile.style.width = `${initSlideWidth}%`;
    productMediaSlider.addEventListener("swiperChange", function(event) {
      const activeIndex = event.detail.activeSlideIndex;
      const slides = event.detail.slides;
      const slideWidth = 100 / slides;
      const indicatorPosition = slideWidth * activeIndex;
      sliderIndicatorMobile.style.width = `${slideWidth}%`;
      sliderIndicatorMobile.style.transform = `translateX(${indicatorPosition * slides}%)`;
    });
  }
};
if (customElements.get("product-media-scroll-indicator-mobile") === void 0) {
  customElements.define("product-media-scroll-indicator-mobile", ProductMediaScrollIndicatorMobile);
}
